import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const GetMyAccountSettings = graphql(`
  query MyAccountSettings {
    me {
      user {
        account {
          id
          ...ProposalPaymentOptions_Account
          ...CompanySettingsChatAgent_Account
        }
      }
    }
  }
`);

const useGetMyAccountSettings = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.accountSettings(),
    queryFn: () => gqlClient.request(GetMyAccountSettings),
  });

  return {
    account: data?.me.user.account,
    ...rest,
  };
};

export default useGetMyAccountSettings;
